module.exports = __webpack_public_path__ + "components/country-flag/static/ie-41391e96764cfedcc78178cb0f72f2ad.svg";